(ns frontend.view.components.upload
  (:require
   [potpuri.core :as p :refer [fn->]]
   [common.localization :as loc]
   ;;            [cljsjs.dropzone]
   [basic-components.popover :as popover]
   [frontend.utils :as fu]))

(defn image-gallery-logo
  [image-url]
  (if image-url
    [:div.draft__image-gallery-logo
     [:img
      {:src (fu/sanitize-img-url image-url)}]]
    [:div.draft__wide-logo-wrapper.mt-2
     [:div.draft__wide-logo-upload-box
      [:i.fas.fa-plus]
      [:span.draft__wide-logo-upload-title
       (loc/tr :file-upload/select-image)]]]))

(defn logo
  [image-url css-class]
  [:div
   {:class-name css-class}
   (if image-url
     [:div.draft__logo-image
      [:img
       {:src (fu/sanitize-img-url image-url)}]]
     [:div.draft__logo-wrapper.mt-2
      [:i.fas.fa-plus]
      [:span.draft__logo-upload-title
       (loc/tr :file-upload/select-image)]])])

(defn upload-input
  [{:keys [on-change! input-id accept class]}]
  [:input
   (merge
    {:type      "file"
     :on-drop   (fn [e]
                  (.persist e)
                  (on-change! {:files (-> e
                                          .-dataTransfer
                                          .-files)
                               :original-event e})
                  (.preventDefault e)
                  (.stopPropagation e))
     :on-focus  (fn [e]
                  (.preventDefault e)
                  (.setTimeout js/window
                               (fn []
                                 (.blur (.getElementById js/document input-id)))
                               300)
                  false)
     :id        input-id
     :on-change (fn [e]
                  (.persist e)
                  (on-change! {:files (-> e
                                          .-target
                                          .-files)
                               :original-event e}))}
    (when class
      {:class class})
    (when accept
      {:accept accept}))])

(defn upload-zone
  [{:keys [label lang-kw info css-class accept on-change!]}]
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [label lang-kw info css-class accept on-change!]}]
      (let [lang-kw (or lang-kw :en)]
        [:form
         {:action     "/api/attachment"
          :class-name (fu/cs "file-dropzone"
                             css-class)}
         (when label
           [:label.settings-company2__field-label label])
         [:div.fallback
          [:div.dropzone-instructions
           {:class "text-base-light-text"}
           [:i.fal.fa-cloud-upload]
           [:span
            (loc/tr :dropzone-instructions-pre-link nil lang-kw)]
           [:span.dropzone-instructions-link
            {:class "text-base-light-text-accent"}
            (loc/tr :dropzone-instructions-link nil lang-kw)]

           [:span.dropzone-info-text
            (when info
              info)]]
          [upload-input
           {:on-change! on-change!
            :input-id   input-id
            :accept     accept}]]]))))

(defn custom-upload-zone
  [{:keys [label lang-kw info css-class accept on-change! pre-link-text link-text post-link-text]}]
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [label lang-kw info css-class accept on-change! pre-link-text link-text post-link-text]}]
      (let [lang-kw (or lang-kw :en)]
        [:form
         {:action     "/api/attachment"
          :class-name (fu/cs "file-dropzone"
                             css-class)}
         [:div.fallback.border-radius
          [:div.dropzone-instructions
           [:i.fal.fa-upload]
           [:div.d-flex.justify-content-center
            [:span.text-bold.text-sm.mb-0
             (loc/tr (or pre-link-text :custom-dropzone-pre-link) nil lang-kw)]
            [:span.text-bold.d-inline-block.pl-1.text-sm.mb-0.text-color--theme
             (loc/tr (or link-text :custom-dropzone-link) nil lang-kw)]]
           [:span
            {:class-name (fu/cs (if-not post-link-text
                                  "dropzone-info-text text-bold"
                                  "text-bold text-sm mb-0"))}
            (loc/tr (or post-link-text :custom-dropzone-post-link) nil lang-kw)]]
          [upload-input
           {:on-change! on-change!
            :input-id   input-id
            :accept     accept}]]]))))

(defn upload-block
  []
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [label info class-name on-change!]}]
      [:form
       {:action     "/api/attachment"
        :class-name (fu/cs "file-dropzone upload-zone"
                           class-name)}
       (when label
         [:label.upload-block__label label])
       [:div.fallback
        [:div.dropzone-instructions
         [:i.fal.fa-cloud-upload]
         [:span.dropzone-instructions-link
          (loc/tr :upload-from-device)]
         [:span
          (loc/tr :upload-or-drag-drop)]
         [:span.dropzone-info-text
          (when info
            info)]]
        [upload-input
         {:on-change! on-change!
          :input-id   input-id}]]])))
